module.exports = __webpack_public_path__ + "img/27.fd72eece.jpg";